'use strict';

function LoansTopNavigation() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MoneyController];

  // The default page priority is at 2000.
  // the lower the value, the higher the priority
  // we want this top tray to load before the page
  this.priority = 800;

  this.init = function () {
    this._super();
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    var _this = this;

    var destinationUrl = this.determineMoneyRoute();

    if (destinationUrl === this.paths.loans.preapproval) {
      this.tabItems = [{
        title: 'Offers',
        url: '/member/dashboard/loans/preapproval',
        ariaControls: 'Offers'
      }];
    } else {
      this.tabItems = [{
        title: 'Overview',
        url: '/member/dashboard/loans/overview',
        ariaControls: 'Overview'
      }, {
        title: 'Offers',
        url: '/member/dashboard/loans/offers',
        ariaControls: 'Offers'
      }];
    }

    this.presenter.addComputedVariable('is_super_hot_lead', ['money.offers.offers'], function () {
      return _this.isSuperHotLead();
    });

    if (!this.isSuperHotLead()) {
      this.tabItems.push({
        title: 'MoneyClass',
        url: '/member/dashboard/loans/educational',
        ariaControls: 'MoneyClass',
        analyticsId: 'MogoMoney-Navigation-MoneyClass-Navigation-Component'
      });
    }

    if (this.tabItems.length > 1 && $('#LoansTabNavigation').length > 0) {
      $('#LoansTabNavigation').mogo().create('TabsNavigation', {
        tabs: this.tabItems
      });
    }
  };

  this.isSuperHotLead = function () {
    var isHotLead = this.presenter.getModelProperty('account.credit_seeker_status') === 'hot_lead';
    var hasOrHadLoan = this._getLoanStatus() && (this._getLoanStatus().status === 'active' || this._getLoanStatus().status === 'paid_off' || this._getLoanStatus().status === 'closed');
    return isHotLead && !hasOrHadLoan;
  };

  this.destroy = function () {};
}